function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M29.979,18.383C30.331,23.623,26.167,28,21,28h-4c-1.105,0-2-0.895-2-2v0c0-1.105,0.895-2,2-2h4 c2.922,0,5.267-2.52,4.976-5.5c-0.254-2.597-2.589-4.5-5.199-4.5L11,14v5.286c0,0.633-0.765,0.949-1.212,0.502L2,12l7.788-7.788 C10.235,3.765,11,4.082,11,4.714V10l9.682,0C25.471,10,29.659,13.605,29.979,18.383z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/undo.ece5a81e.svg";
export { SvgComponent as ReactComponent };